import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiltroPipe } from '../../pipes/search-filtro.pipe';
import { TimeFormatPipe } from '../../pipes/time-format.pipe';
import { DatetimeFormatPipe } from '../../pipes/datetime-format.pipe';
import { MaskedUrlPipe } from '../../pipes/url.pipe';

const pipes = [
  FiltroPipe,
  TimeFormatPipe,
  DatetimeFormatPipe,
  MaskedUrlPipe
]

@NgModule({
  declarations: pipes,
  imports: [
    CommonModule
  ],
  exports: pipes
})
export class PipesModule { }
